import "./styles/style.less";
import { MainRouter } from "./Layout/MainRouter";

function App() {
  return <MainRouter />;
}

export default App;
